/* ----------------------------General Constants---------------------------- */
/* ---------------The constants that generally use everywhere--------------- */

export const env = "Production"; //localhost || Production || Staging
// Date
export const BOOK_DAY_LIMIT = 729;

// Date format
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_DISPLAY_FORMAT = "YYYY-MM-DD";

// Form Label
export const LABEL_SIZE_XXLARGE = "xxlarge";
export const LABEL_SIZE_XLARGE = "xlarge";
export const LABEL_SIZE_LARGE = "large";
export const LABEL_SIZE_REGULAR = "regular";
export const LABEL_SIZE_SMALL = "small";

// Regex
export const REGEX_NUMBER_N_DOT = /[^0-9.]/g;
export const CONTACT_NUMBER_REGEX = /^[+0-9][-\s0-9]*$/;
export const EMAIL_ADDRESS_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$/;
export const PRICE_REGEX = /^\d*(\.\d{0,2})?$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{12,20}$/;

// Image
export const BLANK_IMAGE =
  "https:dashboard-operator-image.s3.amazonaws.com/3386bffc-75c9-4390-a670-fc11ed8febe1_blanksquare.png";

// Roles
export const ROLE_ADMIN = "admin";
export const ROLE_ADVISOR = "advisor";

/* ----------------------------Specific Constants---------------------------- */
/* ---------------The constants that generally use in one page--------------- */
// Unit Listings Page
export const SORTING_CRITERIAS = [
  {
    value: "priceAscending",
    label: "Lowest to Highest Price",
    isDefault: true,
  },
  { value: "priceDescending", label: "Highest to Lowest Price" },
];

export const ScreenSize = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const PrimaryColor = "#D7A301";

// GPT Solution
export const defaultGptProjectId = "670d3de052d122c8fa681122";
